module.exports = __webpack_public_path__ + "img/info-icon.47616bdc.svg";